/**
 * Two settings whose values are named by features that live elsewhere in the
 * desktop app — notifications (§12) and live probes (§5.23) — kept here so the
 * settings documents and their validators can be read without either feature.
 */

/**
 * How much a workspace's sessions may interrupt.
 *
 * `attention` is the interesting value: it is everything that has *stopped* —
 * an agent waiting on an answer, a workflow gate, a held connection, a failure —
 * and nothing that merely finished. `all` adds the handback, which is the one a
 * person actually waits for and also the one that arrives while they are busy.
 */
export type NotifyMode = 'off' | 'attention' | 'all';

export const NOTIFY_MODES: readonly NotifyMode[] = ['off', 'attention', 'all'];

/**
 * What a workspace allows (§4.1). `attach` is free: probes reach what is already
 * reachable — every Node process, the page, any JVM or interpreter someone
 * started under a debugger. `ready` also *starts* projects under one and puts
 * the debuggers in the session image, which costs something per runtime and is
 * why it is a choice rather than the default.
 */
export type ProbeMode = 'off' | 'attach' | 'ready';
export const PROBE_MODES: readonly ProbeMode[] = ['off', 'attach', 'ready'];
